import { render, staticRenderFns } from "./CommonFormWithSystemCalendarEditor.vue?vue&type=template&id=2be42197&lang=pug&"
import script from "./CommonFormWithSystemCalendarEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithSystemCalendarEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithSystemCalendarEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports